var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.633,
    height: 12.996,
    viewBox: "0 0 15.633 12.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-store",
    d: "M15.283 3.01 13.635.381A.813.813 0 0 0 12.947 0H2.693a.813.813 0 0 0-.688.381L.358 3.01A2.264 2.264 0 0 0 1.85 6.472a2.638 2.638 0 0 0 .35.028 2.506 2.506 0 0 0 1.873-.84 2.508 2.508 0 0 0 3.746 0 2.508 2.508 0 0 0 3.746 0 2.515 2.515 0 0 0 1.873.84 2.609 2.609 0 0 0 .348-.023 2.262 2.262 0 0 0 1.497-3.467zm-1.84 4.3a3.22 3.22 0 0 1-.749-.1v2.537H2.947V7.214a3.362 3.362 0 0 1-.749.1 3.425 3.425 0 0 1-.457-.03 3.192 3.192 0 0 1-.416-.091v5a.811.811 0 0 0 .812.807h11.371a.811.811 0 0 0 .812-.812v-5a2.592 2.592 0 0 1-.416.091 3.53 3.53 0 0 1-.462.031z",
    transform: "translate(-.004)",
    fill: "#3c2f87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.8c052b55149bea964c369317a3aec978.svg";
export { ForwardRef as ReactComponent };